module.exports = __webpack_public_path__ + "media/images/landing/persons/kristyna-patykova-747a807ec511ae7d2b25f2fd1e8b8d5a.jpg";